import { call, put } from 'redux-saga/effects';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import MESSAGES from '../../constants/messages';
import { retriable } from '../retriable';
import {
    FETCH_INVOICE_DETAILS_SUCCESSS,
    FETCH_INVOICE_LINE_DATA_SUCCESSS,
    FETCH_INVOICE_LIST_DATA_SUCCESSS,
} from '../../redux/modules/invoice/invoice-actions';
import { addSeekDirectionAndParamsToUrlParams } from '../../constants/UrlUtil';
import { getInvoiceListSearchConstruct } from '../../containers/InvoiceListContainer/InsuranceInvoiceUtil';

export function* getInsuranceInvoiceListWorker(action) {
    try {
        const {
            searchText,
            filters,
            page,
            size,
            seekDirection,
            seekParams,
        } = action;
        const api = addSeekDirectionAndParamsToUrlParams(
            `${action.api}?size=${size}`,
            seekDirection,
            seekParams,
        );
        const searchConstruct = getInvoiceListSearchConstruct(filters, searchText);
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(
            retriable().post,
            api,
            searchConstruct,
        );
        yield put({
            type: FETCH_INVOICE_LIST_DATA_SUCCESSS,
            data: {
                ...response.data,
                page,
                size,
            },
            filters,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        if (e.response && e.response.data && e.response.data.message) {
            yield put({ type: ERROR_MESSAGE, message: e.response.data.message });
        } else {
            yield put({ type: ERROR_MESSAGE, message: MESSAGES.INSURANCE_INVOICE.ERROR_IN_INSURANCE_INVOICE_FETCH });
        }
    }
}

export function* getInsuranceInvoiceLinesWorker(action) {
    try {
        const api = `${action.api}?insuranceInvoice=${action.uuid}`;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(
            retriable().get,
            api,
        );
        yield put({
            type: FETCH_INVOICE_LINE_DATA_SUCCESSS,
            data: response.data,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        if (e.response && e.response.data && e.response.data.message) {
            yield put({ type: ERROR_MESSAGE, message: e.response.data.message });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: MESSAGES.INSURANCE_INVOICE.ERROR_IN_INSURANCE_INVOICE_LINE_FETCH,
            });
        }
    }
}

export function* getInsuranceInvoiceDetailsWorker(action) {
    try {
        const api = `${action.api}?uuid=${action.uuid}`;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(
            retriable().get,
            api,
        );
        yield put({
            type: FETCH_INVOICE_DETAILS_SUCCESSS,
            data: response.data,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        if (e.response && e.response.data && e.response.data.message) {
            yield put({ type: ERROR_MESSAGE, message: e.response.data.message });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: MESSAGES.INSURANCE_INVOICE.ERROR_IN_INSURANCE_INVOICE_LINE_FETCH,
            });
        }
    }
}

export function* updateInsuranceInvoiceLineWorker(action) {
    try {
        const api = `${action.api}?invoiceUuid=${action.uuid}`;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(
            retriable().put,
            api,
            action.data,
        );
        yield put({
            type: FETCH_INVOICE_LINE_DATA_SUCCESSS,
            data: response.data,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        if (e.response && e.response.data && e.response.data.message) {
            yield put({ type: ERROR_MESSAGE, message: e.response.data.message });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: MESSAGES.INSURANCE_INVOICE.ERROR_IN_INSURANCE_INVOICE_LINE_FETCH,
            });
        }
    }
}
